
riot.tag2('comment-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#reviews/comments"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;comments&quot;, &quot;0100&quot;) : checkPermission(&quot;comments&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">Комментарий к товару:<b>{item.nameProduct}</b></div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-2">\n          <div class="form-group">\n            <label class="control-label">Дата</label>\n            <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}"></datetime-picker>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.idPrice}">\n            <label class="control-label">Товар</label>\n            <div class="input-group">\n              <div class="input-group-btn"><a class="btn btn-default" if="{item.idPrice}" href="#products/{item.idPrice}" target="_blank"><i class="fa fa-eye"></i></a></div>\n              <input class="form-control" name="nameProduct" type="text" value="{item.nameProduct}" readonly>\n              <div class="input-group-btn">\n                <div class="btn btn-default" onclick="{changeProduct}"><i class="fa fa-list text-primary"></i></div>\n              </div>\n            </div>\n            <div class="help-block">{error.idPrice}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-8">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Автор комментария</label>\n            <input class="form-control" name="name" type="text" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-4">\n          <div class="form-group {has-error: error.email}">\n            <label class="control-label">Email</label>\n            <input class="form-control" name="email" type="text" value="{item.email}">\n            <div class="help-block">{error.email}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label">Комментарий</label>\n            <textarea class="form-control" rows="5" name="commentary" style="min-width: 100%; max-width: 100%;" value="{item.commentary}"></textarea>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <div class="form-group">\n            <label class="control-label"><b>Ответ администратора</b></label>\n            <textarea class="form-control" rows="5" name="response" style="min-width: 100%; max-width: 100%;" value="{item.response}"></textarea>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.item = {};

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = {
    idPrice: 'empty',
    name: 'empty',
    email: 'email'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.submit = function (e) {
    var params = self.item;

    self.error = self.validation.validate(self.item, self.rules);
    if (!self.error) {
        API.request({
            object: 'Comment',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
                self.item = response;
                if (self.isNew) riot.route('/reviews/comments/' + self.item.id);
                self.update();
                observable.trigger('comments-reload');
            }
        });
    }
};

self.changePerson = function () {
    modals.create('persons-list-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0) {
                self.item.idUser = items[0].id;
                self.item.nameUser = items[0].displayName;
                self.update();
                this.modalHide();
            }
        }
    });
};

self.changeProduct = function () {
    modals.create('products-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0) {
                self.item.idPrice = items[0].id;
                self.item.nameProduct = items[0].name;
                self.update();
                this.modalHide();
            }
        }
    });
};

observable.on('comment-edit', function (id) {
    var params = { id: id };
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.update();

    API.request({
        object: 'Comment',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
        },
        error: function error(response) {
            self.item = {};
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
});

observable.on('comment-new', function () {
    self.isNew = true;
    self.item = {};
    self.update();
});

self.reload = function () {
    observable.trigger('comment-edit', self.item.id);
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/comments/comment-edit.tag